import { z } from 'zod'

import { existingStrategyValuesSchema } from '../shared/strategy-values.schema'

export const updateStrategySchema = (strategyTypes: string[]) => existingStrategyValuesSchema(strategyTypes)
export type UpdateStrategyValues = z.infer<ReturnType<typeof updateStrategySchema>>
